import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class DocFieldsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async deleteLookupConfiguration(
    lookup_config_id: string,
  ): Promise<any> {
    return super.delete(
      api.update_lookup_configuration.replace(':id', lookup_config_id),
      {},
    );
  }

  public async deleteLovLookupConfiguration(
    lookup_config_id: string,
  ): Promise<any> {
    return super.delete(
      api.lookup_lov_configuration + '/by-id/' + lookup_config_id,
      {},
    );
  }

  public async createLookupConfiguration(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.create_lookup_configuration, formData);
  }

  public async updateLookupConfiguration(
    data: any,
    lookup_id: string,
  ): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(
      api.update_lookup_configuration.replace(':id', lookup_id),
      formData,
    );
  }

  public async deleteConfigField(
    lookup_config_id: string,
    field_config_id: string,
  ): Promise<any> {
    logInfo(lookup_config_id, field_config_id);
    return super.delete(
      api.update_fields
        .replace(':lookup_id', lookup_config_id)
        .replace(':field_id', field_config_id),
      {},
    );
  }

  public async deleteLovConfigField(
    lookup_config_id: string,
    field_config_id: string,
  ): Promise<any> {
    return super.delete(
      api.lov_lookup_configurations_fields.replace(':id', lookup_config_id) +
        '/' +
        field_config_id,
      {},
    );
  }

  public async updateFields(
    data: any,
    lookup_id: string,
    field_id: string,
  ): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(
      api.update_fields
        .replace(':lookup_id', lookup_id)
        .replace(':field_id', field_id),
      formData,
    );
  }

  public async createConfigField(
    lookup_config_id: string,
    data: any,
  ): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(
      api.create_config_field.replace(':id', lookup_config_id),
      formData,
    );
  }

  public async getFieldsForConfiguration(
    lookup_config_id: string,
  ): Promise<any> {
    return super.get(
      api.lookup_configurations_fields.replace(':id', lookup_config_id),
      {},
    );
  }

  public async getLovFieldsForConfiguration(
    lookup_config_id: string,
  ): Promise<any> {
    return super.get(
      api.lov_lookup_configurations_fields.replace(':id', lookup_config_id),
      {},
    );
  }

  public async getLookUpConfigurations(doc_type: string): Promise<any> {
    const queryParams = 'doc_type=' + doc_type;
    return super.get(api.lookup_configurations + '?' + queryParams, {});
  }

  public async getAll(): Promise<any> {
    return super.get(api.get_sub_organisations);
  }

  public async getFieldSettingsByType(data: any): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_field_settings_by_type + '?' + querystring, {});
  }
  public async restoreSupplierField(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(api.restore_supplier_fields, formData);
  }

  public async update(data: any, query_params: any): Promise<any> {
    const querystring = this.encodeQueryData(query_params);

    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.update_field_settings + '?' + querystring, formData);
  }

  public async restoreDefaultFields(
    data: any,
    query_params: any,
  ): Promise<any> {
    const querystring = this.encodeQueryData(query_params);

    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(
      api.settings_restore_defaults + '?' + querystring,
      formData,
    );
  }

  public async createField(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.create_document_field, formData);
  }

  public async createGroup(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.create_document_field_group, formData);
  }

  public async getGroupsByDocType(data: any): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_document_field_groups + '?' + querystring, {});
  }

  public async deleteField(id: string): Promise<any> {
    return super.delete(api.delete_document_field + '/' + id, {});
  }

  public async reassignFieldsToGroup(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.assign_group_to_fields, formData);
  }

  public async deleteGroups(id: string): Promise<any> {
    return super.delete(api.delete_document_field_group + '/' + id, {});
  }
  public async getFieldsForAllDocTypes(): Promise<any> {
    return super.get(api.get_all_documents_field_settings, {});
  }

  public async toggleActivationStatus(id: string): Promise<any> {
    return super.post(
      api.toggle_config_activation_status.replace(':id', id),
      new FormData(),
    );
  }

  public async toggleLovActivationStatus(id: string): Promise<any> {
    return super.post(
      api.toggle_lov_config_activation.replace(':id', id),
      new FormData(),
    );
  }

  public async duplicateConfig(id: string, name: string): Promise<any> {
    const formData = new FormData();
    formData.append('lookup_name', name);

    return super.post(api.duplicate_config.replace(':id', id), formData);
  }

  public async duplicateLovConfig(id: string, name: string): Promise<any> {
    const formData = new FormData();
    formData.append('lookup_name', name);

    return super.post(api.lov_duplicate_config.replace(':id', id), formData);
  }

  public async getLookupLovConfiguration(doc_type: string): Promise<any> {
    const queryParams = 'doc_type=' + doc_type;
    return super.get(api.get_lookup_lov_configuration + '?' + queryParams, {});
  }

  public async saveConfiguration(lovId: string, data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    let url = api.lookup_lov_configuration;
    if (lovId) {
      return super.put(url + '/by-id/' + lovId, formData);
    } else {
      return super.post(url, formData);
    }
  }

  public async saveLovFieldConfig(
    configId: string,
    fieldId: string,
    data: any,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('lookup_field_name', data.lookup_field);
    formData.append('filter_value', data.filter_value ? data.filter_value : '');
    formData.append('filter_field_id', data.filter_field_id);
    formData.append('is_required', String(data.is_required));

    let url = api.lov_lookup_configurations_fields.replace(':id', configId);

    if (fieldId) {
      url += '/' + fieldId;
      return super.put(url, formData);
    }
    return super.post(url, formData);
  }
}
